var _excluded = ["variant", "lines", "width", "widthLastChildren"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Box } from '@creditas-ui/layout';
import { SkeletonLine as Skeleton } from './SkeletonText.styles';
import { linesFactory, isLast } from './useSkeletonText';

var SkeletonText = _ref => {
  var {
    variant = 'heading',
    lines = 2,
    width,
    widthLastChildren
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, {
    width: width
  }, linesFactory(lines).map((_, index) => {
    var isLastSkeleton = isLast(lines, index);
    return /*#__PURE__*/React.createElement(Skeleton, _extends({
      key: index,
      variant: variant,
      isLast: isLastSkeleton,
      maxWidth: isLastSkeleton ? widthLastChildren || '80%' : '100%'
    }, props));
  }));
};

export { SkeletonText };
//# sourceMappingURL=SkeletonText.js.map